import { Intent } from '../@types/intent'

export enum TrackingEventType {
  BL = 'BASIC_LEADS',
  BR = 'BASIC_REQUEST',
  RL = 'RICH_LEADS',
  RR = 'RICH_REQUEST',
}

export const getBasicLeadTrackingType = (intent?: Intent): TrackingEventType => {
  return intent === Intent.MAKLER_SALE || intent === Intent.MAYBE_MAKLER_SALE
    ? TrackingEventType.BL
    : TrackingEventType.BR
}

export const normalizeStreetForHashing = (streetName: string) =>
  streetName
    .toLowerCase()
    .replace(/^(.*?)(str\.?|straße?)$/, '$1')
    .replace(/[^a-z\d]+/g, '')
    .replace(/ /g, '')

export const normalizeForHashing = (value: string) => value.toLowerCase().replace(/ /g, '')

export const hashValue = async (value: string | null | undefined) =>
  value ? calculateSHA256Hash(normalizeForHashing(value)) : null

export const hashStreetValue = async (street: string | null | undefined) =>
  street ? calculateSHA256Hash(normalizeStreetForHashing(street)) : null

export const calculateSHA256Hash = async (value: string | undefined | null): Promise<string | null> => {
  if (!value) return null
  const data = new TextEncoder().encode(value)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  return Array.from(new Uint8Array(hashBuffer))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')
}
